import * as React from "react";
import Skeleton from "react-loading-skeleton";

const SkeletonWrapper = ({ loading, children, ...props }) => {
  if (loading) {
    return <Skeleton count={props.count || 1} style={{ minWidth: "150px" }}></Skeleton>;
  } else {
    return children;
  }
};

export default SkeletonWrapper;
